module.exports = __webpack_public_path__ + "static/media/WHIP_LIST_COLOR.35aee8dd.png";